<template>
	<div class="create-container nat-create-container">
		<div class="create-host">
			<div class="jc-page-header">
				<div class="jc-container">
					<el-page-header show-back-icon :title="$t('nat.text.createNat')" @back="jump_to_up()" class="relative">
						<template slot="content">
							<div class="jc-list__header--right">
								<a :href="Config.BUY_HELP_URL" target="_blank" class="fr buy-info">
									{{ $t('create.text.buyMustKnow') }}
								</a>
							</div>
						</template>
					</el-page-header>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container pr">
					<div class="buildTab">
						<ul>
							<li id="tab1" @click="setTab('tab', 1, 2)" class="hover">
								{{ $t('create.text.yearlyOrMonthly') }}
								<div class="jc-badge-discount">{{ $t('create.text.sale') }}</div>
							</li>
							<li id="tab2" @click="setTab('tab', 2, 2)" v-if="isVip">
								{{ $t('create.text.byConfigurations') }}
								<div class="jc-badge-discount">{{ $t('create.text.sale') }}</div>
							</li>
						</ul>
					</div>
					<div class="buildCon" id="con-tab-1">
						<div class="infoBox">
							<!-- 地域与可用区 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.regionAndAz') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" @submit.native.prevent>
									<el-form-item :label="$t('create.text.region') | withColon">
										<el-radio-group v-model="selectedRegion" @change="regionChange">
											<el-radio-button v-for="(regionName, region, index) in regions" :key="index"
												:label="region">
												{{ regionName }}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.tooltip.region') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item :label="$t('create.text.az') | withColon">
										<el-radio-group v-model="selectedZone">
											<el-radio-button v-for="(azName, az, index) in zones[selectedRegion]"
												:key="index" :label="az">
												{{ azName }}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.tooltip.az') }}</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
							<!-- 规格 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.spec') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item :label="$t('create.text.spec') | withColon">
										<el-radio-group v-model="selectSpecification" style="margin-left:10px">
											<el-radio-button v-for="specification in specifications"
												:label="specification.value" :key="specification.value">{{
													specification.label }}</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
											<div slot="content" class="my-os-disk-tip">{{ $t('nat.speechCraft.natTypeTip')
											}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="ml10">{{ $t('nat.speechCraft.maxLinkTip') }}</p>
										<p class="ml10">{{ $t('nat.speechCraft.maxNewTip') }}</p>
									</el-form-item>
								</el-form>
							</div>
							<!-- 网络 -->
							<div class="jc-page-card network-info" id="network">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.net') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" ref="networkInfo"
									:rules="networkInfoRules" :model="netInfo">
									<!-- 私有网络 -->
									<el-form-item :label="$t('privateNetInstance.privateNet') | withColon"
										class="net-select" prop="selectVpcId">
										<el-select style="width: 520px" v-model="netInfo.selectVpcId" class="select-vpc" @change="vpcChange"
											@visible-change="getRealTimeVpc"
											:placeholder="$t('privateNetInstance.chooseVPC')">
											<el-option v-for="(vpc, index) in vpcShowList" :key="index"
												:label="vpc.showName" :value="vpc.vpcId">
											</el-option>
										</el-select>
										<el-button type="text" @click="jumpToVpcList">
											{{ $t('privateNetInstance.createPrivateNetwork') }}
										</el-button>
										<span slot="hint" v-if="netInfo.selectVpcId && netInfo.selectVpcCidr">{{
											$t('privateNetInstance.privateNetCidr', [netInfo.selectVpcCidr]) }}</span>
										<span slot="hint" v-if="netInfo.selectVpcId && netInfo.selectVpcIpv6Cidr">{{
											$t('privateNetInstance.privateNetIpv6Cidr', [netInfo.selectVpcIpv6Cidr])
										}}</span>
									</el-form-item>
								</el-form>
							</div>
							<!-- 带宽 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.bandwidth') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" :model="netInfo">
									<el-form-item :label="$t('create.text.publicIp') | withColon">
										<input id="controlCheckbox" type="checkbox" v-model="netInfo.radioIp" />
										<span class="network-ip">{{ $t('create.text.autoVpc') }}</span>
										<p slot="hint" class="auto-vpc-tip">{{ $t('create.text.autoVpcTip') }}</p>
									</el-form-item>
									<div id="agreeControlArea" v-if="netInfo.radioIp">
										<el-form-item :label="$t('create.text.banCalModel') | withColon">
											<el-radio-group v-model="selectedPaymentType">
												<el-radio-button :label="$t('create.placeholder.fixedBandwidth')">
												</el-radio-button>
											</el-radio-group>
											<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
												<div slot="content" class="my-os-disk-tip">
													{{ $t('create.tooltip.cal') }}<a v-bind:href="Config.Band_Width_BillUrl"
														target="_blank" style="color:#2C68FF">{{ $t('create.tooltip.detail')
														}}&gt;&gt;</a>
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
										</el-form-item>
										<el-form-item :label="$t('create.text.line') | withColon">
											<el-radio-group v-model="netInfo.selectedLineType">
												<el-radio-button v-for="(item, key, index) in lineTypes" :key="index"
													:label="key">{{ item }}
												</el-radio-button>
											</el-radio-group>
											<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
												<div slot="content" class="my-os-disk-tip">
													{{ $t('create.tooltip.line', [lineTypes[netInfo.selectedLineType]]) }}
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
										</el-form-item>
										<el-form-item :label="$t('create.text.bandLimit') | withColon">
											<div class="el-form-item-inline">
												<el-slider v-model="netInfo.tmpMaxBandwidth" show-input
													@change="(val) => calSelectedMaxBandwidth(val, 'netInfo')" :max="200"
													:debounce="0" :min="1" :marks="marks" class="jc-slider-custom">
												</el-slider>
											</div>
											<p class="el-form-item-help tip-height">
												{{ $t('create.help.ddosVpc') }}
												<a v-bind:href="Config.DDOS_URL" target="_blank">
													{{ $t('create.help.ddosVpcGuid') }}
												</a>
											</p>
										</el-form-item>
									</div>
								</el-form>
							</div>
							<!-- 基本信息 -->
							<div id="baseInfo" class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.baseInfo') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" :model="ruleForm"
									ref="ruleForm" :rules="rules" @submit.native.prevent>
									<!--实例名称-->
									<el-form-item :label="$t('subnet.text.name') | withColon" prop="hostName"
										:show-message="false" required ref="hostName">
										<el-input style="width: 520px"  v-model="ruleForm.hostName" @blur="ruleFormTag.hostName = 1"
											@focus="ruleFormTag.hostName = 0"></el-input>
										<p v-if="ruleFormTag.hostName !== 0 && ruleForm.hostName == ''"
											class="el-form-item-help-error">
											{{ $t('create.placeholder.nameNull') }}</p>
										<p v-else class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.hostName == 'error' }">
											{{ $t('create.help.instanceNameRule') }}</p>
									</el-form-item>
								</el-form>
							</div>
							<!-- 购买量 -->
							<div class="jc-page-card" v-if="currentMode === 'tab1'">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.buyNo') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item :label="$t('create.text.buyTimeSpan') | withColon">
										<div class="my-time-length">
											<div class="time-slide">
												<ul class="time-choose cl">
													<!--0折用户-->
													<el-tooltip effect="dark" placement="top"
														v-if="allDiscountedInfo[index - 1].message[0] !== ''"
														v-for='index in firstNine'>
														<div slot="content">
															{{ allDiscountedInfo[index - 1].message[0] }} <br />
															{{ allDiscountedInfo[index - 1].message[1] }}
														</div>
														<li @click="selectMonth(index)" :class="getClass(index)">
															<i></i>{{ index }}
														</li>
													</el-tooltip>
													<!--普通用户-->
													<li v-for='index in firstNine' @click="selectMonth(index)"
														:class="getClass(index)"
														v-if="allDiscountedInfo[index - 1].message[0] === ''">
														{{ index }}
													</li>
													<!--0折用户-->
													<el-tooltip effect="dark" placement="top"
														v-if="allDiscountedInfo[index + 8].message[0] !== ''"
														v-for='index in lastThree'>
														<div slot="content">
															{{ allDiscountedInfo[index + 8].message[0] }} <br />
															{{ allDiscountedInfo[index + 8].message[1] }}
														</div>
														<li @click="selectYear(index)" class="time-discount"
															:class="getClass(12 * index)">
															<i></i>{{ index + $tc('create.text.yearUnit', index) }}
														</li>
													</el-tooltip>
													<!--普通用户-->
													<li v-for='index in lastThree' @click="selectYear(index)"
														:class="getClass(12 * index)"
														v-if="allDiscountedInfo[index + 8].message[0] === ''"
														class="time-discount">
														{{ index + $tc('create.text.yearUnit', index) }}
													</li>
												</ul>
											</div>
										</div>
									</el-form-item>
									<!--自动续费-->
									<el-form-item :label="$t('create.text.autoRenew') | withColon">
										<input id="autoRenewCheckbox" type="checkbox" v-model="autoRenew" />
										<span>{{ $t('create.text.autoRenewTip') }}</span>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-app-tip">
												{{ $t('create.tooltip.autoRenew') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
					<!-- 已选配置 -->
					<div id="selected" class="jc-form-create-selected">
						<h3 class="selected-title">
							{{ $t('create.text.selectedConfig') }}</h3>
						<el-form label-width="120px" class="jc-datashow-list">
							<section class="selected-configure">
								<!--地域-->
								<el-form-item :label="$t('create.text.region')">
									<p>{{ regions[selectedRegion] | maybeEmpty }}</p>
								</el-form-item>
								<!--可用区-->
								<el-form-item :label="$t('create.text.az')" :title="$t('create.text.az')">
									<p>{{ zones[selectedRegion][selectedZone] | maybeEmpty }}</p>
								</el-form-item>
								<!--规格-->
								<el-form-item :label="$t('create.text.spec')"
									:title="specificationTypeDict[selectSpecification] + $t('nat.text.choosedSpecification', [SpecificationTypeSnatMax[selectSpecification]])">
									<p class="selected-ellipsis">
										{{ specificationTypeDict[selectSpecification] +
											$t('nat.text.choosedSpecification', [SpecificationTypeSnatMax[selectSpecification]])
										}}
									</p>
								</el-form-item>
								<!--私有网络-->
								<el-form-item :label="$t('privateNetInstance.privateNet')">
									<p>{{ netInfo.selectVpcName | maybeEmpty }}</p>
								</el-form-item>
								<!--带宽-->
								<el-form-item :label="$t('create.text.publicIp')">
									<p v-if="lineTypes[netInfo.selectedLineType] && netInfo.radioIp == true">
										{{ $t('create.help.byBandwidth', [lineTypes[netInfo.selectedLineType],
										netInfo.selectedMaxBandwidth]) }}
									</p>
									<p v-else>--</p>
								</el-form-item>
								<!--购买时长-->
								<el-form-item v-if="currentMode === 'tab1'" :label="$t('create.text.buySpan')"
									:title="$t('create.text.buyTimeSpan')">
									<p v-if="selectedMonth % 12 != 0">
										{{ selectedMonth }} {{ $tc('create.text.month', selectedMonth) }}
									</p>
									<p v-else-if="selectedMonth % 12 == 0">{{ selectedMonth / 12 }}
										{{ $tc('create.text.yearUnit', selectedMonth / 12) }}
									</p>
									<p v-else>--</p>
								</el-form-item>
								<!--购买数量-->
								<el-form-item :label="$t('create.text.buyNum')">
									<p>{{ selectedHostNumber }}</p>
								</el-form-item>
							</section>
							<!--费用-->
							<section class="selected-cost">
								<h3 class="selected-cost-title">
									{{ $t('create.text.cost') }}</h3>
								<!--包年包月计费-->
								<div v-if="currentMode === 'tab1'">
									<!--nat-->
									<el-form-item :label="$t('nat.text.nat')">
										<p class="form-item-nopadding"
											:class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price highlight-font-color">￥{{ discountedServerPrice }}</span>
											<span class="none">{{ calTotalPrice.discountedServerPrice }}</span>
										</p>
									</el-form-item>
									<!--主网口eip-->
									<el-form-item v-if="netInfo.radioIp" :label="$t('create.text.publicIp')">
										<p class="form-item-nopadding"
											:class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price cff96">￥{{ discountedMainEipPrice }}</span>
											<span class="none">{{ calTotalPrice.discountedMainEipPrice }}</span>
										</p>
									</el-form-item>
									<p v-if="totalDiscount > 0"
										class="form-item-nopadding form-item-bottom selected-ellipsis">
										<span class="jc-form-item__label w70" :title="$t('create.text.original')">{{
											$t('create.text.original') }}</span>
										<span class="price"
											style="font-size:12px;text-decoration:line-through;margin:6px 0;margin-left:11px">￥{{
												totalPrice }}</span>
										<span class="ml20 highlight-font-color" :title="'￥' + favorablePricePerHour">{{
											$t('create.text.save') }}：￥{{ favorablePricePerHour }}</span>
									</p>
								</div>
								<!--按配置计费-->
								<div v-else>
									<!--nat-->
									<el-form-item v-if="currentMode === 'tab2'" :label="$t('nat.text.nat')">
										<p class="form-item-nopadding"
											:class="[configurationTotalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price highlight-font-color" style="font-size: 21px;">
												{{ $t('create.text.feePerHour',
													[discountByConfigurationsServerPriceOneHour]) }}</span>
											<span class="none">{{
												configurationCalTotalPrice.discountByConfigurationsServerPriceOneHour
											}}</span>
										</p>
									</el-form-item>
									<!--eip-->
									<el-form-item v-if="netInfo.radioIp" :label="$t('create.text.publicIp')">
										<p class="form-item-nopadding"
											:class="[configurationTotalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price cff96" style="font-size: 21px;">
												{{ $t('eip.text.feePerHour', [discountByConfigurationsMainEipPriceOneHour])
												}}
											</span>
											<span class="none">
												{{ configurationCalTotalPrice.discountByConfigurationsMainEipPriceOneHour }}
											</span>
											<span class="none">
												{{ calTotalPrice.discountedTotalPrice }}
											</span>
										</p>
									</el-form-item>
									<p class="month-total-price">
										<span>{{ $t('create.text.configureMonthPay',
											[discountByConfigurationsOneMonthPrice]) }}</span>
										<span class="none">{{
											configurationCalTotalPrice.discountByConfigurationsOneMonthPrice }}</span>
									</p>
									<p v-if="configurationTotalDiscount > 0"
										class="form-item-nopadding form-item-bottom selected-ellipsis">
										<span class="jc-form-item__label w70" :title="$t('create.text.original')">{{
											$t('create.text.original') }}</span>
										<span class="price"
											style="font-size:12px;text-decoration:line-through;margin:6px 0;margin-left:11px">￥{{
												configurationTotalPrice }}</span>
										<span class="ml20 highlight-font-color" :title="'￥' + configurationTotalDiscount">{{
											$t('create.text.save') }}：￥{{ configurationTotalDiscount }}</span>
									</p>
								</div>
								<el-button type="primary" size="large" :disabled="!natQuotaIsEnough
									|| !isCertification
									|| !EipStockIsEnough
									|| !EipQuotaIsEnough" class="my-buy-btn" @click="buy">{{ $t('create.text.buyNow') }}
								</el-button>
								<p v-if="currentMode === 'tab2'" class="like-form-help-item">
									{{ $t('create.text.yearPackage', [discountedTotalPrice]) }}
								</p>
								<p v-if="!isCertification" class="red mt10">
									{{ $t('create.help.noCertification') }}
									<a :href="Config.REALNAME_URL">
										{{ $t('create.help.goCertificate') }}</a>
								</p>
								<p v-else-if="!natQuotaIsEnough" class="red">
									{{ $t('nat.help.natOverStock') }}{{ $t('create.help.contact') }}
									<a :href="Config.WORK_URL" target="_blank">{{ $t('create.tooltip.ticket') }}</a>
								</p>
								<p v-else-if="natQuotaIsEnough && netInfo.radioIp" class="eip-tip-info">
									<span v-if="eipInfo.available < selectedHostNumber">
										{{ $t('eip.help.soldOut') }}
										<a :href="Config.WORK_URL" target="_blank">
											{{ $t('eip.help.openTicket') }}
										</a>
										<span>{{ $t('eip.help.increaseLimit') }}</span>
									</span>
									<span v-else-if="eipInfo.availableQuota < selectedHostNumber">
										{{ $t('create.help.EipExceedQuota') }}{{ $t('create.help.contact') }}
										<a :href="Config.WORK_URL" target="_blank">
											{{ $t('create.tooltip.ticket') }}
										</a>
									</span>
								</p>
							</section>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import VueCookie from 'vue-cookie';
import { NetworkTypeConstant, CreateTypeConstant, I18nConstant, ServiceCodeConstant, BillingTypesConstant, SpecificationType, SpecificationTypeSnatMax, SpecificationTypeParamsDict } from '@/common/Constants';
import ifCertification from '@/mixins/ifCertification';
import { changeTwoDecimal, mulDecimals, subDecimals } from '@/common/tool';
import initSelectedPotision from '@/mixins/initSelectedPotision';
import buyTime from '@/mixins/buyTime';
export default {
	components: {
	},
	mixins: [ifCertification, initSelectedPotision, buyTime],
	data() {
		return {
			currentMode: 'tab1',
			isVip: false, // 是否为大客户(true: 是)
			// 规格
			selectSpecification: 's',
			specifications: SpecificationType,
			eipInfo: {
				availableQuota: 0,
				available: 0
			},
			networkInfoRules: {
				selectVpcId: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				]
			},
			netInfo: {
				vpcCount: 0,
				vpcList: [],
				selectVpcId: '',
				selectVpcName: '',
				selectVpcCidr: '',
				selectVpcIpv6Cidr: '',
				selectedLineType: 'bgp',
				radioIp: true,
				tmpMaxBandwidth: 1,
				selectedMaxBandwidth: 1,
			},
			natQuota: 0,
			creatVisibile: false,
			// 区域
			selectedRegion: '',
			selectedZone: '',
			// 带宽
			selectedPaymentType: this.$t('create.placeholder.fixedBandwidth'),
			//带宽上限的上限和下限
			marks: { 1: '1Mbps', 200: '200Mbps' },
			// 基本信息
			hostName: '',
			// 购买数量
			selectedMonth: 1,
			cutMonth: 0,
			selectedHostNumber: 1,
			// 包年包月价格
			discountedTotalPrice: 0,
			discountedServerPrice: 0,
			discountedMainEipPrice: 0,
			totalPrice: 0,
			totalDiscount: 0,
			// 按配置价格
			discountByConfigurationsTotalPrice: 0,
			discountByConfigurationsOneMonthPrice: 0,
			discountByConfigurationsServerPriceOneHour: 0,
			discountByConfigurationsMainEipPriceOneHour: 0,
			configurationTotalPrice: 0, // 按配置计价总费用
			configurationTotalDiscount: 0, // 按配置计价折扣额
      favorablePricePerHour: '', // // 省 = 原价 - 应付
			// 页面参数选择
			regions: {},
			zones: { '': {} },
			// 用于页面倒叙展示规格
			otherMonth: 0,
			lineTypes: {},
			// 表单验证
			ruleForm: {
				hostName: '',
			},
			ruleFormTag: {
				hostName: 0,
			},
			rulesType: {
				type: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				]
			},
			rules: {
				hostName: [
					{
						type: 'string',
						pattern: new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$'),
						trigger: 'blur'
					}
				]
			},
			timeUnit: 3,
			chargeUnit: 3, // 月 计费时长单位 1:小时 2:天 3:月 4:年,
			selectedYear: 1, // 选择年份,
			autoRenew: false,//自动续费
			// 折扣信息
			discountedInfo: [
				{ message: '' },
				{ message: '' },
				{ message: '' }
			],
			// 0折用户折扣信息
			allDiscountedInfo: [
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
			],
			// 前9个月
			firstNine: [1, 2, 3, 4, 5, 6, 7, 8, 9],
			// 后三年
			lastThree: [1, 2, 3]
		};
	},
	computed: {
		SpecificationTypeSnatMax: () => SpecificationTypeSnatMax,
		SpecificationTypeParamsDict: () => SpecificationTypeParamsDict,
		/**
		  * 包年包月计算
		  */
		calTotalPrice() {
			return this.calculateTotalPrice();
		},
		/**
		* 按配置计算
		*/
		configurationCalTotalPrice() {
			return this.configurationsCalculateTotalPrice();
		},

		ServiceCodeConstant: () => ServiceCodeConstant,

		/**
		* @return {boolean}
		*/
		EipStockIsEnough() {
			let eipStockIsEnough = true;
			if (this.netInfo.radioIp) {
				eipStockIsEnough = this.natQuota
					&& this.selectedHostNumber <= this.eipInfo.available;
			}
			return eipStockIsEnough;
		},
		/**
		* @return {boolean}
		*/
		EipQuotaIsEnough() {
			let eipQuotaIsEnough = true;
			if (this.netInfo.radioIp) {
				eipQuotaIsEnough = this.natQuota
					&& this.selectedHostNumber <= this.eipInfo.availableQuota;
			}
			return eipQuotaIsEnough;
		},
		natQuotaIsEnough() {
			return this.natQuota >= this.selectedHostNumber;
		},
		vpcShowList() {
			if (this.netInfo.vpcCount === 0) {
				this.netInfo.vpcList = [{
					vpcId: '',
					showName: this.$t('privateNetInstance.notVPC'),
				}];
			} else {
				this.netInfo.vpcList = this.netInfo.vpcList.map(vpc => ({
					vpcId: vpc.vpcId,
					showName: `${vpc.name}(${vpc.vpcId})`,
					name: vpc.name,
					cidr: vpc.cidr,
					ipv6Cidr: vpc.ipv6Cidr
				}));
			}
			return this.netInfo.vpcList;
		},
		specificationTypeDict() {
			let specificationMap = this.specifications.reduce((obj, specification) => {
				obj[specification.value] = specification.label
				return obj
			}, {});
			return specificationMap
		}
	},
	watch: {
		selectedRegion(newValue, oldVlue) {
			if (newValue) {
				if (this.zones[this.selectedRegion]) {
					for (const az in this.zones[this.selectedRegion]) {
						this.selectedZone = az;
						break;
					}
				} else {
					this.selectedZone = '';
				}
				this.getUserType();
				this.getNatQuota();
				this.getVpcCount();
				this.getDiscountInfo();
				this.getEipQuota();
				this.getEipStock();
				this.getLineTypes();
			}
		}
	},
	created() {
		this.getRegion();
		this.getUserIsCertification();
	},
	methods: {
		/**
		* 获得用户类型
		*/
		getUserType() {
			const params = {
				region: this.selectedRegion
			};
			Ajax.get('/api/usercenter/describeBaseInfo', params)
				.then((res) => {
					res.data = JSON.parse(res.data.meta);
					if (typeof res.data.edcps_vip !== 'undefined') {
						this.isVip = res.data.edcps_vip.toString() === '1';
						this.setTab('tab', 1, 1)
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});;
		},
		/**
		 * 区域切换时更新数据
		 * 切换时带宽值，购买数量初始化为1
		 * @param region
		 * */
		regionChange(region) {
			this.selectedHostNumber = 1;
			this.netInfo.tmpMaxBandwidth = 1;
			this.netInfo.selectVpcId = '';
			setTimeout(() => {
				this.$refs.networkInfo.resetFields();
			}, 2000);
		},
		/*
		*  当前页面可以跳转其它页面创建vpc
		*  当创建完返回该页面时
		*  下拉操作后确保为最新的数据
		* */
		getRealTimeVpc(isVisible) {
			if (isVisible) {
				this.getVpcCount();
			}
		},
		jumpToVpcList() {
			const { href } = this.$router.resolve({
				name: 'PrivateNetworkList'
			});
			window.open(href, '_blank');
		},

		// 查询EIP配额
		getEipQuota() {
			const params = {
				region: this.selectedRegion
			};
			Ajax.get('/api/cps/eipQuota', params)
				.then((res) => {
					this.eipInfo.availableQuota = res.data.availableQuota;
				});
		},
		// 查询EIP库存
		getEipStock() {
			const params = {
				region: this.selectedRegion
			};
			Ajax.get('/api/bm/stock', params)
				.then((res) => {
					this.eipInfo.available = res.data.result.available;
				});
		},

		// 获取选中vpc名称
		getSelectVpcName(vpcId) {
			this.netInfo.vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this.netInfo.selectVpcName = vpc.name;
				}
			});
		},
		// 获取选中vpc cidr及ipv6 cidr
		getSelectVpcCidr(vpcId) {
			this.netInfo.vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this.netInfo.selectVpcCidr = vpc.cidr;
					this.netInfo.selectVpcIpv6Cidr = vpc.ipv6Cidr;
				}
			});
		},
		// 获取选中当前vpc
		vpcChange(id) {
			if (id) {
				this.getSelectVpcName(id);
				this.getSelectVpcCidr(id);
			}
		},
		// 获取当前区域下vpc
		getVpcCount() {
			const params = {
				region: this.selectedRegion,
				service: 'nat',
				pageSize: 100
			};
			Ajax.get('/api/cps/listVpcs', params)
				.then((res) => {
					if (res.data.vpcs) {
						this.netInfo.vpcList = res.data.vpcs;
						this.netInfo.vpcCount = res.data.vpcs.length;
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},

		getClass(num) {
			if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.CN || VueCookie.get(this.GLOBALCOOKIE) == null) {
				if (num === this.selectedMonth) {
					return 'cur';
				}
				if (this.selectedMonth > num) {
					return 'sel';
				}
				return '';
			}
			if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.EN) {
				if (num === this.selectedMonth) {
					if (this.selectedMonth == 1) {
						return 'curSingleEn curEn';
					}
					return 'curEn';
				}
				if (this.selectedMonth > num) {
					return 'sel';
				}
				return '';
			}
		},

		getNatQuota() {
			const param = {
				region: this.selectedRegion
			};
			Ajax.get('/api/cps/nat/natQuota', param)
				.then((res) => {
					this.natQuota = res.data.availableQuota;
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		getRegion() {
			const param = {
				networkType: NetworkTypeConstant.VPC
			};
			Ajax.get('/api/cps/getRegions', param)
				.then((res) => {
					for (const i in res.data.regions) {
						const region = res.data.regions[i].region;
						const regionName = res.data.regions[i].regionName;
						const zones = res.data.regions[i].azs;
						this.regions[region] = regionName;
						for (const j in zones) {
							const az = zones[j].az;
							const azName = zones[j].azName;
							if (typeof this.zones[region] === 'undefined') {
								this.zones[region] = {};
							}
							this.zones[region][az] = azName;
						}
					}
					const passedRegion = this.$route.query.region;
					if (passedRegion != undefined) {
						this.selectedRegion = passedRegion;
						this.selectedZone = this.regions[passedRegion];
					} else {
						this.selectedRegion = res.data.regions[0].region;
						this.selectedZone = res.data.regions[0].azs[0].az;
					}
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		getLineTypes() {
			const param = {
				region: this.selectedRegion
			};
			Ajax.get('/api/cps/getLineTypes', param)
				.then((res) => {
					const data = res.data.lineTypes;
					this.lineTypes = data.reduce((lineTypes, item) => {
						lineTypes[item.lineType] = item.lineTypeName
						return lineTypes
					}, {});
					this.netInfo.selectedLineType = Object.keys(this.lineTypes)[0];
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		calculateTotalPrice() {
			if (!this.selectedRegion) {
				return '';
			}
			this.discountedTotalPrice = this.$t('create.text.calculating');
			this.totalPrice = this.$t('create.text.calculating');
			this.totalDiscount = this.$t('create.text.calculating');
			const param = {
				cmd: 1, // 创建
				region: this.selectedRegion,
				deviceType: this.SpecificationTypeParamsDict[this.selectSpecification],
				timeUnit: this.timeUnit, // 月
				timeSpan: this.timeUnit == 3 ? this.selectedMonth : this.selectedYear,
				bw: this.netInfo.radioIp ? this.netInfo.selectedMaxBandwidth : 0,
				count: this.selectedHostNumber,
				createType: CreateTypeConstant.NAT,
				billingType: BillingTypesConstant.PREPAID_BY_DURATION
			};
			Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
        const { discountedTotalPrice, list, totalPrice, totalDiscount } = res?.data || {};
				this.discountedTotalPrice = changeTwoDecimal(discountedTotalPrice);
				this.discountedServerPrice = changeTwoDecimal(list.length ? list[0]?.discountedPrice : '');
				if (this.netInfo.radioIp) {
					this.discountedMainEipPrice = changeTwoDecimal(list.length && list[1] && list[1]?.discountedPrice);
				}
				this.totalPrice = changeTwoDecimal(totalPrice);
				this.totalDiscount = changeTwoDecimal(totalDiscount);
        this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : null;
			})
			return '';
		},
		configurationsCalculateTotalPrice() {
			if (!this.selectedRegion) {
				return '';
			}

			this.discountByConfigurationsTotalPrice = this.$t('create.text.calculating');
			this.discountByConfigurationsOneMonthPrice = this.$t('create.text.calculating');
			const param = {
				cmd: 1, // 创建
				region: this.selectedRegion,
				deviceType: this.SpecificationTypeParamsDict[this.selectSpecification],
				bw: this.netInfo.radioIp ? this.netInfo.selectedMaxBandwidth : 0,
				count: this.selectedHostNumber,
				createType: CreateTypeConstant.NAT,
				billingType: BillingTypesConstant.POSTPAID_BY_DURATION
			};
			Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
        const { discountedTotalPrice, list, totalPrice, totalDiscount } = res?.data || {};
				this.discountByConfigurationsTotalPrice = changeTwoDecimal(discountedTotalPrice);
				this.discountByConfigurationsOneMonthPrice = changeTwoDecimal(mulDecimals(mulDecimals(discountedTotalPrice, 24), 30));
				this.discountByConfigurationsServerPriceOneHour = changeTwoDecimal(list.length ? list[0]?.discountedPrice : "");
				if (this.netInfo.radioIp) {
					this.discountByConfigurationsMainEipPriceOneHour = changeTwoDecimal(list.length && list[1] && list[1]?.discountedPrice);
				}
				this.configurationTotalPrice = changeTwoDecimal(totalPrice);
				this.configurationTotalDiscount = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : null;
			})
			return '';
		},
		calSelectedMaxBandwidth(val) {
			this.netInfo.selectedMaxBandwidth = this.netInfo.tmpMaxBandwidth;
		},
		selectMonth(selMonth) {
			this.chargeUnit = 3;
			this.timeUnit = 3;
			this.selectedMonth = selMonth;
			this.otherMonth = selMonth;
			switch (selMonth) {
				case 12:
					this.cutMonth = 2;
					break;
				case 24:
					this.cutMonth = 4;
					break;
				case 36:
					this.cutMonth = 6;
					break;
				default:
					this.cutMonth = 0;
			}
		},
		selectYear(selYear) {
			switch (selYear) {
				case 1:
					this.selectedMonth = 12;
					break;
				case 2:
					this.selectedMonth = 24;
					break;
				case 3:
					this.selectedMonth = 36;
					break;
				default:
					this.cutMonth = 0;
			}
			this.selectedYear = selYear;
			this.chargeUnit = 4;
			this.timeUnit = 4;
		},
		jump_to_up() {
			this.$router.push({
				path: '/nat/list',
				query: {
					region: this.selectedRegion
				}
			});
		},
		/**
		 **@disc:定位到页面上未通过校验元素
		 **@params: element id
		 */
		locateToErrorElement(id) {
			$('.mainCon').scrollTop($('.mainCon').scrollTop() + $(`#${id}`).offset().top
				- $('.mainCon').offset().top - 100);
		},
		buy() {
			let formValid = true;
			this.$refs.networkInfo.validate((valid) => {
				formValid = valid;
			});
			if (!formValid) {
				this.locateToErrorElement('network');
				return false;
			}
			this.$refs.ruleForm.validate((valid) => {
				formValid = valid;
			});

			if (!formValid) {
				this.ruleFormTag.hostName = this.$refs.hostName.validateState;
				this.locateToErrorElement('baseInfo');
				return false;
			}
			this.createOrder();
		},
		createOrder() {
			const param = {
				orderType: 1, // 新购
				chargeMode: this.currentMode === 'tab1' ? 3 : 1, // 计费类型 包年包月
				region: this.selectedRegion,
				az: this.selectedZone,
				vpcId: this.netInfo.selectVpcId,
				vpc: this.netInfo.selectVpcName,
				cidr: this.netInfo.selectSubnetCidr,
				lineType: this.netInfo.selectedLineType,
				bw: this.netInfo.radioIp ? this.netInfo.selectedMaxBandwidth : 0,
				name: this.ruleForm.hostName,
				chargeDuration: this.chargeUnit == 3 ? this.selectedMonth : this.selectedYear,
				chargeUnit: this.chargeUnit, // 月 计费时长单位 1:小时 2:天 3:月 4:年
				quantity: this.selectedHostNumber,
				clientToken: Normal.getClientToken(),
				autoRenew: this.autoRenew,
				networkType: 'vpc',
				createType: 'vpc',
				enableInternet: this.netInfo.radioIp ? 'yes' : 'no',
				natGatewayType: this.SpecificationTypeParamsDict[this.selectSpecification],
				orderType: 1
			};
			Ajax.post('/api/cps/nat/addNatGateway', param, {
				headers: {
					'Content-Type': 'application/json'
				}
			}).then((res) => {
				const orderId = res.data.tempOrderNumber;
				if (orderId) {
					window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
				}
			})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		setTab(name, cursel, n) {
			for (let i = 1; i <= n; i++) {
				const menu = document.getElementById(name + i);
				const con = document.getElementById(`con-${name}-${i}`);
				menu.className = i == cursel ? 'hover' : '';
			}
			this.currentMode = name + cursel;
		},
		// 获取折扣信息
		getDiscountInfo() {
			const param = {
				serviceCode: ServiceCodeConstant["EIP|NAT"],
				billType: 2, // 包年包月
				billPeriod: '1,2,3',
				timeUnit: 4, // 年
				region: this.selectedRegion,
				buyType: 1// 1、新购2、续费3、配置变更
			};
			Ajax.get('/api/discount/describeLowestDiscount', param).then((res) => {
				if (res.data.length > 0) {
					let allDiscountedInfo = JSON.parse(JSON.stringify(this.allDiscountedInfo))
					this.allDiscountedInfo = res.data.reduce((obj, item, index) => {
						obj[index].message[0] = item.discounts[0].message;
						obj[index].message[1] = item.discounts[1].message;
						return obj
					}, allDiscountedInfo)
				}
			})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},

		doClose() {
			this.dialogVisible = false;
		},
		doConfirm() {
			this.dialogVisible = false;
		},

		jumpToVpcList() {
			this.$router.push({
				path: '/vpc/list',
			})
		}
	}
};
</script>

<style lang="scss">
@import '../../../assets/scss/createCommon';
@import '../../../assets/scss/selectedConfigure';
@import '../../../assets/scss/sliderCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/nat/create/Create.vue